import React from 'react';
import {WeaSearchGroup, WeaFormItem, WeaBrowser} from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import EType from './base/EType';
import ETitle from './base/ETitle';

// 文档内容
export default class Content_25 extends React.Component {
    state = {
        eDocContentFormIds: this.props.eDocContentFormIds,
        eDocContentForm: this.props.eDocContentForm
    };

    render() {
        const {eDocContentForm} = this.state;
        let linkUrl = ``;
        if(eDocContentForm.length > 0) {
            linkUrl = `/spa/document/index.jsp?id=${eDocContentForm[0].id}&router=1#/main/document/detail?id=`;
        }
        let EDocContentFrom = <div></div>;
        if (this.props.eShareLevel == '2') {
            EDocContentFrom = (
                <WeaFormItem label={getLabel(20885, '内容来源')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                    <WeaBrowser
                        type={9}
                        hasAdvanceSerach
                        isUseTest
                        icon="icon-toolbar-Organization-list"
                        iconBgcolor="#b32e37"
                        quickSearchName="docsubject"

                        searchsubject={false}
                        isSingle={true}
                        replaceDatas={eDocContentForm || []}
                        linkUrl={linkUrl}
                        onChange={(ids, names, datas) => this.setState({eDocContentFormIds: ids, eDocContentForm: datas})}
                    />
                </WeaFormItem>
            );
        }

        return (
            <div>
                <WeaSearchGroup title={getLabel(81711, '基本信息')} needTigger={true} showGroup={true}>
                    <EType ref="eType" value={this.props.eBaseName}/>
                    {this.props.eShareLevel == '2' ? <ETitle ref="eTitle" eid={this.props.eid} value={this.props.eTitle}/> : ''}
                    {EDocContentFrom}
                </WeaSearchGroup>
            </div>
        );
    }

    getSaveValues() {
        return {
            eContentTitle: this.refs['eTitle'] ? this.refs['eTitle'].getSaveValues() : this.props.eTitle,
            eContentDocContentForm: this.state.eDocContentFormIds,
        };
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_25.js